<template>
  <PageShell class="page-shell-wrapper--legal" locale="id" :page-title="pageTitle">
    <LegalContent slug="disclaimer" />
  </PageShell>
</template>

<script>
import PageShell from '@/components/layout/PageShell.vue';
import LegalContent from './LegalContent.vue';

export default {
  name: 'DisclaimerPage',
  components: { PageShell, LegalContent },
  computed: {
    pageTitle() {
      return this.$route.meta.pageTitle || '';
    },
  },
};
</script>
